<template>
  <div style="background: white">
    <prohead></prohead>
    <div class="banner" style="background: url('../../static/img/k_bg.jpg');text-align: center;position: relative">
      <div style="position: absolute;left: 42%">开心玩国儿童乐园+</div>
    </div>





    <div style="background: #ffffff">



      <div class="box5_banner" style="padding-top: 40px;" >

        <div>
          <ul class="tab-title">
            <li v-for="(title,index) in tabTitle" @click="cur=title.cate_name" :class="{active:cur==title.cate_name}">{{title.cate_name}}</li>
          </ul>
        </div>

      </div>



      <div class="banner_kai"  id="fzlc" style="padding-bottom: 50px;height: 1100px;" v-show = "cur == '品牌简介'">
        <div style="text-align: center">
          <div class="titlebox" style="padding-top: 45px">品牌简介</div>
          <p class="title_fu">brand</p>
          <img class="" style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">

        </div>

        <div class="banner_pin" style="padding-top: 40px">
<!--          <div style="margin-right: 18px" class="titimgh"><img src="../../static/img/k_logo.png" alt=""></div>-->
          <div style="width: 1300px" class="banner_pintext">
            <div>
              <p>开心玩国儿童乐园+，品牌总部位于北京，创立于2005年，经过10余年的探索、积累与创新，现已成长为中国“融合式儿童乐园+时代”的开创者与领航者。</p>
              <br>
              <p>“一切围绕孩子的快乐建设，一切围绕孩子的成长服务”。</p>
              <p>是儿童乐园，也是欢乐世界，拥有完全自主知识产权的场景式品牌文化，以沉浸体验和创新主题场景为特色，
                采用国际一流的理念和技术精心打造，为乐园注入新的文化标签与开心因子，被誉为“室内Disney”、“儿童乐园+时代标杆”。</p>
              <br>
              <p>“以实际体验和用户口碑作为根本的经营之道”。</p>
              <p>始终秉承以用户体验和口碑为根本的经营之道，不断探索行业更多的发展可能性，不断调整完善以优化品牌与竞争的综合实力。</p>
              <br>
              <div style="margin-top: 10px;margin-bottom: 10px">
                <img style="float: left;margin-right: 20px" src="../../static/img/one.png" alt="" class="titi">
                <img style="float: left;margin-right: 20px"src="../../static/img/t.png" alt="" class="titi">
                <img style="float: left;margin-right: 20px"src="../../static/img/th.png" alt="" class="titi">
                <img style="float: left;"src="../../static/img/6eb5e2d56db1ca24ee26f2f17dc3d4f.jpg" alt="" class="titi">
              </div>
              <p>“超级儿童乐园一站式综合服务平台”。</p>
              <p>开心玩国品牌总部，深耕儿童领域，现拥有超500人的运营管理精英团队和5000+实体门店，辐射中国32个省份、直辖市及自治区。
                拥有自己的儿童玩乐研究所与乐园产品研发中心，从设计生产、研发能力，到市场营销、开店管理以及品牌战略，都有独到优势与实力。真正的“儿童乐园产业一站式服务方案供应商”。</p>
              <br>
              <p>开心玩国全球连锁布局为创业投资者开启财富新世界。</p>
              <p>集团早已在上海股权交易中心成功挂牌上市，正高速进行“资本助力”的第2个10年发展计划。
                小玩国大梦想，开心玩国正以惊人的速度全面开启品牌的扩张之路。理念更新、模式更新、项目更全、服务更优，
                立志成为儿童乐园+时代的产业中坚力量，为亿万孩子的童年添加欢乐注解，也为更多创业投资者打开一扇新的财富之门！</p>
              <div style="margin-top: 10px">
                <div style="margin-top:50px">
                  <div>
                    <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
                    <div style="float:left;margin-left: 40px;margin-top: -10px; text-align: left;margin-right: 40px;">
                      <p style="font-size: 18px;font-weight: 500;color: #333333;">创始</p>
                      <div style="font-size: 60px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;margin-top: 10px">2005 <span style="font-size: 16px;">年</span></div>
                    </div>
                    <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
                    <div style="float:left;margin-left: 68px;margin-top: -10px; text-align: left;margin-right: 68px;">
                      <p style="font-size: 18px;font-weight: 500;color: #333333;">行业积累</p>
                      <div style="font-size: 60px;margin-top: 10px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">20 <span style="font-size: 16px;">年</span></div>
                    </div>
                    <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
                    <div style="float:left;margin-left: 50px;margin-top: -10px; text-align: left;margin-right: 50px;">
                      <p style="font-size: 18px;font-weight: 500;color: #333333;">总部人才支持</p>
                      <div style="font-size: 60px;margin-top: 10px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">500 <span style="font-size: 16px;">+</span></div>
                    </div>
                    <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
                    <div style="float:left;margin-left: 40px;margin-top: -10px; text-align: left;margin-right: 40px;">
                      <p style="font-size: 18px;font-weight: 500;color: #333333;">全国优秀门店</p>
                      <div style="font-size: 60px;margin-top: 10px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">5000 <span style="font-size: 16px;">+</span></div>
                    </div>
                    <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
                    <div style="float:left;margin-left: 80px;margin-top: -10px; text-align: left;margin-right: 40px;">
                      <p style="font-size: 18px;font-weight: 500;color: #333333;">经验快速入行</p>
                      <div style="font-size: 60px;margin-top: 10px;font-family: CTChaoHeiSF;font-weight: 400;color: #EA5C48;">0 <span style="font-size: 16px;"></span></div>
                    </div>
                    <div style="float: left"><img src="../../static/img/000.png" alt=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box3" style="height: 920px" id="gsjj" v-show = "cur == '项目概述'">
      <div class="box_banner2">
        <div class="titlebox" style="color: #000;padding-top: 30px">一次奇妙的探索之旅 一个开心的魔力玩国</div>
        <p style="color: #000;padding-top: 10px">WELCOME TO EXPLORE</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="" >

        <div class="box_imgbanner" style="color: #000">
          <div style="margin-right: 29px;">
            <img src="../../static/img/img.png" alt="" class="titimghs">
          </div>
          <div>
            <p>我们不一样。</p>
            <p>我们更好玩。</p>
            <br>
            <p><span style="color: #D76056">“Welcome to explore ”，</span>欢迎来探索，这是开心玩国对大家的欢迎辞。</p>
            <p>进入开心玩国，是一次全新的乐园体验，当你沉浸其中，张开想象力的翅膀，奇妙的事情就发生了……</p>
            <br>
            <p>可以穿越到“失落的Maya世界”，感受金字塔尖的繁盛与文明；</p>
            <p>可以回到1955，做一回真正的Disney在逃公主；</p>
            <p>可以在Cool车小镇，开上心爱的小车体验驾驶的乐趣；</p>
            <p>还可以在“问天X号”，漫步在星辰大海或是星球大战的世界；</p>
            <p>还可以来“未来实验室”，在妙趣横生中体会创造的奇妙； ……</p>
            <p>还有越玩越强壮的专业“体适能中心”</p>
            <p>还有.....太多太多你想不到的新玩乐空间.</p>
            <br>
            <p>自此，一个与众不同的 <span style="color: #D76056">[开心玩国]</span></p>
            <p>便以其独一无二的场景故事讲述和沉浸式体验开启了儿童游乐园的新纪元！</p>
            <br>
            <p>[开心玩国]的构想：</p>
            <p>以沉浸式体验与创造性玩乐为核心，集儿童游乐场，场景体验，主题活动，创造试验，原创</p>
            <p>IP,玩具博览等活动事物于一体，让孩子在这里探索，在这里体验，在这里成长，在这里为</p>
            <p>未来种下快乐的因子</p>
          </div>
        </div>
      </div>
    </div>
    <div class="banner_kai" id="ryzz" style="height:1100px" v-show="cur == '品牌文化'">
      <div style="text-align: center">
        <div class="titlebox"  style="padding-top: 45px">品牌文化</div>
        <p class="title_fu">culture</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>


      <div class="banner_pin" style="padding-top: 40px">
<!--        <div style="margin-right: 61px" class="titimgh"><img src="../../static/img/shiming.png" alt=""></div>-->
        <div style="width: 1300px" class="banner_pintext">
          <div style="  line-height: 46px;">
            <p style="font-size: 30px;color: #EA5C48">不只是“儿童乐园”是“开心”“玩”“国”</p>
            <br>
            <p><span style="color:  #EA5C48">[ 开心 ]</span> 开心，是儿童乃至整个人类的情感需求，童年开心，一生幸福。</p>
            <p><span style="color:  #EA5C48">[  玩  ]</span> 孩子的世界，没有比“玩”更重要的事。会玩的人，才更会生活。</p>
            <p><span style="color:  #EA5C48">[ 国 ]</span>儿童乐园的国度，无比丰富的游乐设置，温情满满的亲子家园，创新多样的活动整合，更高起点的一个玩国N个乐园。</p>
            <br>
            <span style="color:  #EA5C48">品牌使命：</span>为孩子的梦想而作，为成长的价值而为 <br>
            <span style="color:  #EA5C48">品牌愿景：</span>成为中国儿童乐园产业标杆，打造室内“迪士尼”儿童梦想乐园 <br>
            <span style="color:  #EA5C48">品牌口号：</span>孩子笑了，世界亮了 <br>
            <span style="color:  #EA5C48">品牌价值：</span>激活创造力，快乐力，成长力，幸福力 <br>
            <span style="color:  #EA5C48">品牌理念：</span>以人为本，创新工匠，追求卓越，永不止步 <br>
            <span style="color:  #EA5C48">品牌合作：</span>永守初心，着眼未来，共赢共荣，成就梦想

          </div>
          <div style="margin-top: 30px;">
            <img style="float: left;margin-right: 20px" src="../../static/img/chuang.png" alt="" class="titi">
            <img style="float: left;margin-right: 20px"src="../../static/img/li.png" alt="" class="titi">
            <img style="float: left;margin-right: 20px"src="../../static/img/meng.png" alt="" class="titi">
            <img style="float: left;"src="../../static/img/zao.png" alt="" class="titi">
          </div>
        </div>
      </div>
    </div >
    <div class="banner_kai" style="height: 960px" id="mtsy" v-show = "cur == '荣誉资质'">
      <div style="text-align: center">
        <div class="titlebox"  style="padding-top: 65px">发明专利</div>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>

      <div style="margin-top: 40px;height: 300px">
        <img style="float: left;margin-right: 50px" src="../../static/img/1.png" alt="" class="titi">
        <img style="float: left;margin-right: 50px"src="../../static/img/2.png" alt="" class="titi">
        <img style="float: left;margin-right: 50px"src="../../static/img/3.png" alt="" class="titi">
        <img style="float: left;margin-right: 50px"src="../../static/img/4.png" alt="" class="titi">

        <img style="float: left;"src="../../static/img/5.png" alt="" class="titi">
      </div>
      <div style="text-align: center;margin-top: 40px">
        <div class="titlebox"  style="padding-top: 65px">荣誉证书</div>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
      </div>
      <div style="margin-top: 40px">
        <img style="float: left;margin-right: 65px" src="../../static/img/6.png" alt="" class="titi">
        <img style="float: left;margin-right: 65px"src="../../static/img/7.png" alt="" class="titi">
        <img style="float: left;margin-right: 65px"src="../../static/img/8.png" alt="" class="titi">
        <img style="float: left;margin-right: 65px"src="../../static/img/9.png" alt="" class="titi">

        <img style="float: left;"src="../../static/img/10.png" alt="" class="titi">
      </div>



<!--      <div class="swiper-container">-->
<!--        <div class="swiper-wrapper">-->
<!--          <div class="swiper-slide">-->
<!--            <img src="../../static/img/r.png" alt="">-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <img src="../../static/img/r1.png" alt="">-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <img src="../../static/img/r2.png" alt="">-->

<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <img src="../../static/img/r3.png" alt="">-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <img src="../../static/img/r4.png" alt="">-->

<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; Add Pagination &ndash;&gt;-->
<!--        <div class="swiper-pagination"></div>-->
<!--      </div>-->

    </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import Swiper from "swiper";
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
import {goAnchor,GetQueryString} from '../../static/js/common';

export default {
  name: "index",
  components: {Prohead,Profooter},
  data () {
    return {
      cur: '项目概述',
      tabTitle:[{
        cate_name:'项目概述'
      },{
        cate_name:'品牌简介'
      },{
        cate_name:'品牌文化'
      },{
        cate_name:'荣誉资质'
      }],
      activeIndex: '1',
      activeIndex2: '1',
      navLists:[
        {
          "text":"首页",
          "url":'/'
        },
        {
          "text":"开心玩国",
          "url":'/ProRecommend',
        },
        {
          "text":"创新产品",
          "url":'/ProRecommending',

        },
        {
          "text":"财富世界",
          "url":'/add'
        },
        {
          "text":"加入我们",
          "url":'/Joinus'
        },
        {
          "text":"新闻资讯",
          "url":'/newadd'
        },
        {
          "text":"联系方式",
          "url":'contactus'
        }
      ],
      changeRed:0,
      fullpath:''
    }
  },

  watch: {
    $route(to, from) {
      console.log('lalala',this.$route.query.id)
      if(this.$route.query.id == undefined){
        this.cur = '项目概述'
      }else{
        if (this.$route.query.id) {
          console.log('12131231',this.$route.query.id)

          this.cur = this.$route.query.id
        }
      }

    }
  },

  created() {
    this.cur = '项目概述'
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 5,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: true,
      autoplay: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    this.$nextTick(() => {
      let maodian=this.GetQueryString('maodian');//进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id名
      if(maodian){
        this.goAnchor('#'+maodian);

      }
    });

  },
  methods:{
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 通过 `vm` 访问fetchData，将query参数name，传递过去，进行逻辑处理
        // debugger
        // console.log(to)
        // console.log(from)
        //       console.log(vm.$route); //有值
        //       next()
        if (from.fullPath === "****") {  //关键判断这里区别，自己刷新是 /
          vm.fullpath = from.fullPath;
          this.$router.go(0);
        }

        // vm.fetchData(vm.$route.query.name);
      });
    },
    goAnchor,

    GetQueryString,

  },
}
</script>

<style scoped>
.tab-title{
  width: 1300px;
  height: 100px;
  margin: 0 auto
}
.tab-title li:hover{
  cursor: pointer;
}
.tab-title li{
  width: 180px;
  height: 60px;
  border-radius: 30px;
  float: left;
  border: 1px solid #C5C5C5;
  line-height: 60px;
  text-align: center;
  margin-right: 20px;
  font-size: 18px;
}
.tab-title .active{
  background: #EA5C48;
  color: white;
  cursor: pointer;
  border: 1px solid #EA5C48;

}
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.banner_pin div{
  float: left;
}
.box3{
  margin: 0 auto;
  width: 100%;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
  line-height: 30px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  height: 894px;
  margin: 0 auto;
}
.titi{
  cursor: pointer;
  transition: all 0.6s;
  margin-top: -20px;
}
.titi:hover{
  cursor: pointer;
  transform: scale(1.1);

}
.titimghs{
  cursor: pointer;
  transition: all 0.6s;
  margin-top: -20px;
}
.titimghs:hover{
  cursor: pointer;
  transform: scale(1.1);

}
</style>



// WEBPACK FOOTER //
// src/components/ProRecommend.vue